import { getPhoneMaskValue } from 'src/app/shared/utils/functions';
import { ConfigurationService } from './../../core/services/configuration.service';
import { Component, OnDestroy, OnInit } from '@angular/core';

// const BODY_CLASSES = ['bgi-size-cover', 'bgi-position-center', 'bgi-no-repeat'];

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '<body[root]>',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, OnDestroy {
  today: Date = new Date();
  company:any;

  constructor(private configurationService: ConfigurationService) {}

  ngOnInit(): void {
    // BODY_CLASSES.forEach((c) => document.body.classList.add(c));
    this.company = this.configurationService.companySubject.value;
  }

  ngOnDestroy() {
    // BODY_CLASSES.forEach((c) => document.body.classList.remove(c));
  }

  getPhoneMaskValue(value: string): string {
    return getPhoneMaskValue(value);
  }
}
